import * as THREE from 'three';

/**
 * Configures ambient + directional lights for the neutron star scene.
 * Ambient light provides baseline illumination so no surface is fully black.
 * Directional light ensures surfaces facing the light are visually distinguishable
 * from surfaces facing away.
 */
export class LightingSetup {
  readonly ambientLight: THREE.AmbientLight;
  readonly directionalLight: THREE.DirectionalLight;

  constructor(scene: THREE.Scene) {
    // Ambient light for baseline illumination across all surfaces
    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
    scene.add(this.ambientLight);

    // Directional light so surfaces facing it are visually distinguishable
    // from surfaces facing away
    this.directionalLight = new THREE.DirectionalLight(0xffffff, 1.0);
    this.directionalLight.position.set(5, 10, 7);
    scene.add(this.directionalLight);
  }
}
